export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7950.5de1d9ec.jpg";